<template>
  <div class="login-page">
    <div class="login-page-mainer">
      <div class="login-logo-box">
        <img class="login-logo" src="@/image/logo.png" />
      </div>
      <div class="login-form-container">
        <el-form
          class="login-info"
          :model="teacher"
          :rules="teacherRules"
          ref="teacherRef"
          status-icon
        >
          <div class="login-subtitle">教师登录</div>
          <el-form-item prop="phone">
            <el-input
              v-model="teacher.phone"
              placeholder="请输入手机号码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" :show-message="false">
            <el-input
              v-model="teacher.password"
              type="password"
              placeholder="请输入密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-button
            class="login-btn"
            type="primary"
            @click="login"
            :loading="btnLoading"
            >立即登录</el-button
          >
          <div class="login-contact">忘记密码？登录遇到问题，请联系管理员</div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import userRequest from "@/global/service/user";
import Cookie from "js-cookie";

export default {
  data() {
    return {
      btnLoading: false,
      teacher: {
        phone: null,
        password: null
      },
      teacherRules: {
        phone: [
          { required: true, message: " ", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        password: { required: true, trigger: "blur" }
      }
    };
  },
  created() {},
  methods: {
    login() {
      this.$refs.teacherRef.validate(valid => {
        if (!valid) return;
        this.btnLoading = true;
        userRequest
          .login(this.teacher)
          .then(res => {
            Cookie.set("shiguang_token", res.token, {
              expires: 7,
              domain: process.env.VUE_APP_DOMAIN
            });
            this.$router.push({
              name: "home"
            });
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  height: 100%;
  .login-page-mainer {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 520px;
    text-align: center;
    .login-logo-box {
      display: flex;
      justify-content: center;
      border-bottom: 2px solid #f90;
      .login-logo {
        margin-bottom: 24px;
        width: auto;
        height: 60px;
      }
      .login-logo_text {
        margin-left: 24px;
        height: 60px;
        font-size: 36px;
        line-height: 60px;
      }
    }
    .login-form-container {
      height: 520px;
      box-shadow: 2px 10px 10px rgba(29, 35, 41, 0.05);
      .login-info {
        display: inline-block;
        padding-top: 36px;
        width: 360px;
        .login-subtitle {
          margin-bottom: 24px;
          font-size: 16px;
          font-weight: 400;
          line-height: 16px;
          color: #909399;
        }
        .el-form-item {
          margin-bottom: 30px;
        }
        .login-btn {
          margin: 12px 0;
          width: 100%;
        }
        .login-contact {
          font-size: 12px;
          color: #606266;
        }
      }
    }
  }
}
</style>
